// Captures where a visitor came from (?src= or ?utm_source=) so signups can be attributed.
const KEY = "fb_signup_source";
const REF_KEY = "fb_ref_code";

export function captureSource() {
  const params = new URLSearchParams(window.location.search);
  const src = params.get("src") || params.get("utm_source");
  if (src) localStorage.setItem(KEY, src);
  const ref = params.get("ref");
  if (ref) localStorage.setItem(REF_KEY, ref);
}

export function getSignupSource() {
  const params = new URLSearchParams(window.location.search);
  return params.get("src") || params.get("utm_source") || localStorage.getItem(KEY) || "website";
}

export function getRefCode() {
  const params = new URLSearchParams(window.location.search);
  return params.get("ref") || localStorage.getItem(REF_KEY) || "";
}
